import { watchEntities, findEntities, getEntity, updateEntity, deleteEntity, createEntity, unwatchEntities } from './EntitiesSagas';
import { SitesActions } from '../reducers/SitesRedux'

export function* watchSites(api) {
  yield watchEntities(api, 'site', SitesActions)
}

export function* unwatchSites(api){
  yield unwatchEntities(api, 'site', SitesActions)
}

export function* findSites(api, action) {
  yield findEntities(api, 'site', SitesActions, action)
}

export function* getSite(api, action) {
  yield getEntity(api, SitesActions, action)
}

export function* updateSite(api, action) {
  yield updateEntity(api, SitesActions, action)
}

export function* deleteSite(api, action) {
  yield deleteEntity(api, SitesActions, action)
}

export function* createSite(api, action) {
  yield createEntity(api, SitesActions, action)
}
